import Vue from 'vue'

export default () => {
  const state = Vue.observable({
    documentType: null,
    file: null,
    locations: [],
    sectors: [],
    position: [],
    documentNotification: false,
    documentSignature: false
  })
  const resetState = () => {
    state.documentType = null
    state.file = null
    state.locations = []
    state.sectors = []
    state.position = []
    state.documentNotification = false
    state.documentSignature = false
  }
  return {
    state,
    resetState
  }
}
